import { getVehicles } from "./AdminTools";
import React, { useState, useRef } from 'react';


import * as turf from '@turf/turf';

export function VehiclesUpdater(props) {
  const [vehicles, setVehicles] = useState([]);
  const [session, setSession] = useState(localStorage.getItem("session") || null);
  const [featureCollection, setFeatureCollection] = useState(props.features || []);
  const [visibleVehicles, setVisibleVehicles] = useState(props.visible || []);
  const [rank] = useState(localStorage.getItem("rank") || 0);

  React.useEffect(() => {

    setTimeout(() => {
      getVehicles(session, updateVehicles);
    }, 1000);
    setTimeout(() => {
      getVehicles(session, updateVehicles);
    }, 3000);
    //initVehicles();

    const interval = setInterval(() => {
      let lock = localStorage.getItem("lockvehicles") || false;
      if (lock != "true") getVehicles(session, updateVehicles);
    }, 30000);
    return () => clearInterval(interval);


  }, []);

  React.useEffect(() => {
    //console.log("updater props.features changed");
    //console.log(props.features);
    if (props.features) setFeatureCollection(props.features);
  }, [props.features]);

  React.useEffect(() => {
    if (props.visible) setVisibleVehicles(props.visible);
  }, [props.visible]);



  function compareVehicles(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }



  function checkVehicle(vehicle) {
    if (!visibleVehicles) return false;
    if (!visibleVehicles.length) return false;

    for (var i = 0; i < visibleVehicles.length; i++) {
      if (visibleVehicles[i].esn == vehicle.esn) {
        vehicle.name = visibleVehicles[i].drivername;
        //console.log('hit');
        return true;
      }
    }
    return false;
  }



  function updateVehicles(vehicles) {
    //console.log("update vehicles ");
    //console.log(vehicles);
    vehicles.sort(compareVehicles);
    //console.log('props.visible');
    //console.log(props.visible);
    //console.log('props.features');
    //console.log(props.features);

    if (rank >= 5) {
      //admin or tech
      localStorage.setItem("vehicles", JSON.stringify(vehicles))
      setVehicles(vehicles);
    }
    else {
      var filtered = [];
      if (vehicles) {
        vehicles.forEach(vehicle => {
          if (checkVehicle(vehicle)) { filtered.push(vehicle); }
          else {
            if ((featureCollection) && (featureCollection.features)) featureCollection.features.forEach(feature => {
              if (turf.booleanPointInPolygon([vehicle.longitude, vehicle.latitude], feature)) {
                filtered.push(vehicle);
              }
            });
          } //else
        });
      }
      localStorage.setItem("vehicles", JSON.stringify(filtered))
      setVehicles(filtered);
    }
    dispatchEvent(new Event("vehiclesChanged"));
  }


  function initVehicles() {
    const interval = setInterval(() => {
      let lock = localStorage.getItem("lockvehicles") || false;
      if (lock != "true") getVehicles(session, updateVehicles);
    }, 30000);
    return () => clearInterval(interval);
  }


}

